const _excluded = ["claimGroup", "fieldName", "reportTemplateId", "reportTemplateCategoryId", "onHide", "onContentChanged", "isVisible", "title", "projectId", "sliceId", "fieldId", "claimGroupId", "businessUnitId", "companyId", "subsidiaryCompanyId", "modalType", "isUnderReview", "EditProjectReportSliceModal", "changeSetContainingObject"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import EditClaimGroupFieldModal from './EditClaimGroupFieldModal';
import EditReportTemplateCategoryModal from './EditReportTemplateCategoryModal';
import EditProjectReportNameModal from '../../util/textEdit/modals/EditProjectReportNameModal';
import EditBusinessUnitOverviewModal from './EditBusinessUnitOverviewModal';
import EditSubsidiaryOverviewModal from './EditSubsidiaryOverviewModal';
export default function CompanyReportPreviewEditSectionModal(_ref) {
  let {
      claimGroup,
      fieldName,
      reportTemplateId,
      reportTemplateCategoryId = null,
      onHide,
      onContentChanged,
      isVisible,
      title,
      projectId = null,
      sliceId = null,
      fieldId = null,
      claimGroupId = null,
      businessUnitId = null,
      companyId = null,
      subsidiaryCompanyId = null,
      modalType = null,
      isUnderReview = false,
      EditProjectReportSliceModal,
      changeSetContainingObject
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  function renderModal() {
    switch (modalType) {
      case 'ProjectRemportNameModal':
        return /*#__PURE__*/React.createElement(EditProjectReportNameModal, _extends({
          reportTemplateId: reportTemplateId,
          claimGroupId: claimGroupId,
          projectReportId: projectId,
          onHide: onHide,
          onContentChanged: onContentChanged,
          isVisible: isVisible,
          title: title,
          isUnderReview: isUnderReview
        }, props));
      case 'ClaimGroupFieldModal':
        return /*#__PURE__*/React.createElement(EditClaimGroupFieldModal, _extends({
          claimGroupId: claimGroup.id,
          fieldName: fieldName,
          reportTemplateId: reportTemplateId,
          onHide: onHide,
          onContentChanged: onContentChanged,
          isVisible: isVisible,
          title: title,
          isUnderReview: isUnderReview
        }, props));
      case 'ReportTemplateCategoryModal':
        return /*#__PURE__*/React.createElement(EditReportTemplateCategoryModal, _extends({
          reportTemplateId: reportTemplateId,
          reportTemplateCategoryId: reportTemplateCategoryId,
          onHide: onHide,
          onContentChanged: onContentChanged,
          isVisible: isVisible,
          title: title,
          isUnderReview: isUnderReview
        }, props));
      case 'businessUnitOverviewModal':
        return /*#__PURE__*/React.createElement(EditBusinessUnitOverviewModal, _extends({
          claimGroupId: claimGroup.id,
          businessUnitId: businessUnitId,
          companyId: companyId,
          fieldName: fieldName,
          reportTemplateId: reportTemplateId,
          onHide: onHide,
          onContentChanged: onContentChanged,
          isVisible: isVisible,
          title: title,
          isUnderReview: isUnderReview
        }, props));
      case 'subsidiaryOverviewModal':
        return /*#__PURE__*/React.createElement(EditSubsidiaryOverviewModal, _extends({
          claimGroupId: claimGroup.id,
          subsidiaryCompanyId: subsidiaryCompanyId,
          companyId: companyId,
          fieldName: fieldName,
          reportTemplateId: reportTemplateId,
          onHide: onHide,
          onContentChanged: onContentChanged,
          isVisible: isVisible,
          title: title,
          isUnderReview: isUnderReview
        }, props));
      default:
        return /*#__PURE__*/React.createElement(EditProjectReportSliceModal, _extends({
          reportTemplateId: reportTemplateId,
          onHide: onHide,
          onContentChanged: onContentChanged,
          isVisible: isVisible,
          title: title,
          projectId: projectId,
          sliceId: sliceId,
          fieldId: fieldId,
          claimGroupId: claimGroupId,
          changeSetContainingObject: changeSetContainingObject,
          modalType: modalType,
          isUnderReview: isUnderReview
        }, props));
    }
  }
  return renderModal();
}